import { Button } from 'antd'
import { mdiMapMarkerPlusOutline } from '@mdi/js'
import { FormRender, RenderSchema } from '../../utils/FormRenderer'
import { MinusCircleTwoTone } from '@ant-design/icons'
import { VehicleTypeEnum } from '../../utils/Enums'
import Icon from '@mdi/react'
import { VehiclesCardUnitSchema } from '../../utils/FormSchemas'

const SelectVehiclesCard = (props) => {
	const { form, watcher, orderIndex, vehicleCounter, setVehicleCounter } = props

	const containersSpecifics = Object.values(watcher?.[orderIndex]?.containersSpecifics)?.filter((container) => container?.quantity)
	const totalContainers = containersSpecifics?.reduce((prev, curr) => prev + curr?.quantity, 0)
	const totalVehicles = watcher?.[orderIndex]?.vehicleDetails?.reduce((prev, curr) => prev + parseInt(curr?.quantity), 0)

	const removeVehicleType = (type, index) => {
		const vehicleDetails = form.getFieldValue([orderIndex, type])
		vehicleDetails?.splice(index, 1)
		setVehicleCounter((prevState) => prevState - 1)
		form.setFieldsValue({ [orderIndex]: { [type]: vehicleDetails } })
	}

	return (
		<>
			<div className='mb-3 text-base font-medium leading-5 text-gray-500'>Select Vehicles</div>
			<div className='mb-12 rounded-lg border bg-white p-6'>
				<div className='flex flex-col'>
					{RenderSchema(VehiclesCardUnitSchema({ orderIndex }))}
					{[...Array(vehicleCounter)].map((_, index) => {
						const currentVehicle = parseInt(watcher?.[orderIndex]?.vehicleDetails?.[index]?.quantity)
						return (
							<div className='h-15 flex flex-row items-center justify-start'>
								<div className='w-36'>
									{FormRender({
										type: 'select',
										...(index === 0 && { label: 'Vehicle Type' }),
										name: [orderIndex, 'vehicleDetails', index, 'vehicleType'],
										options: Object.values(VehicleTypeEnum),
										showSearch: true,
										required: true,
										valueProperty: 'key',
										displayProperty: 'text',
										message: 'Vehicle Type is required.',
										placeholder: 'Select Vehicle Type',
									})}
								</div>
								<div div className='ml-5 w-24'>
									{FormRender({
										type: 'number',
										...(index === 0 && { label: 'Min Weight' }),
										name: [orderIndex, 'vehicleDetails', index, 'minWeight'],
										inputType: 'number',
										required: watcher?.[orderIndex]?.vehicleDetails?.[index]?.quotedRateUnit === 'Tonne',
										maxValue: parseInt(watcher?.[orderIndex]?.vehicleDetails?.[index]?.maxWeight) - 1,
										minValue: 1,
									})}
								</div>
								<div div className='ml-5 w-24'>
									{FormRender({
										type: 'number',
										...(index === 0 && { label: 'Max Weight' }),
										name: [orderIndex, 'vehicleDetails', index, 'maxWeight'],
										inputType: 'number',
										required: watcher?.[orderIndex]?.vehicleDetails?.[index]?.quotedRateUnit === 'Tonne',
										minValue: parseInt(watcher?.[orderIndex]?.vehicleDetails?.[index]?.minWeight) + 1,
									})}
								</div>
								<div div className='ml-5 w-28'>
									{FormRender({
										type: 'number',
										...(index === 0 && { label: 'No. of Vehicles' }),
										name: [orderIndex, 'vehicleDetails', index, 'quantity'],
										inputType: 'number',
										required: true,
										maxValue:
											watcher?.[orderIndex]?.specialRequests?.orderCategory === 'shifting'
												? totalContainers - totalVehicles + currentVehicle
												: totalContainers - totalVehicles + currentVehicle - 1,
										message: 'Vehicle number is required.',
										minValue: 1,
									})}
								</div>
								<div div className='ml-5 w-40'>
									{FormRender({
										type: 'number',
										...(index === 0 && { label: 'Quoted Rate' }),
										name: [orderIndex, 'vehicleDetails', index, 'quotedRate'],
										inputType: 'number',
										required: true,
										message: 'Quoted Vehicle Rate is required.',
										minValue: 1,
									})}
									{FormRender({
										type: 'input',
										name: [orderIndex, 'vehicleDetails', index, 'quotedRateUnit'],
										hidden: true,
									})}
								</div>
								{index > 0 && (
									<MinusCircleTwoTone
										twoToneColor='#FF0000'
										className='mb-5 ml-6 cursor-pointer'
										onClick={() => {
											removeVehicleType('vehicleDetails', index)
										}}
									/>
								)}
							</div>
						)
					})}
					{
						<div className='flex w-full items-center justify-end px-6 pb-6'>
							<Button className='btn-dashed py-4' onClick={() => setVehicleCounter((prevState) => prevState + 1)}>
								<Icon path={mdiMapMarkerPlusOutline} size={0.8} className='mr-2' />
								ADD VEHICLE TYPE
							</Button>
						</div>
					}
				</div>
			</div>
		</>
	)
}

export default SelectVehiclesCard
